// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8f3e3e4f","76":"7c466f49","212":"4f816635","882":"c9ef8dfd","912":"c5cb9cc5","935":"fe70b355"}[chunkId] + ".chunk.css";
};